import React from 'react';
import { Fragment, useState, useEffect } from 'react';
import { Row, Alert, Col } from 'react-bootstrap';
import FormBusca from './form_busca';
import DividaService from '../../../services/divida'
import Divida from './divida';

const ListarDividas = () => {


    const [dividas, setDividas] = useState([]);
    const [vazio, setVazio] = useState(false);

    async function fetchDividas() {
        const response = await DividaService.listar();
        if (response.data.length >= 1) {
            setDividas(response.data)
            setVazio(false)
        } else {
            setDividas([])
            setVazio(true)
        }
    }

    useEffect(() => {
        fetchDividas();
    }, []);


    return (
        <Fragment>
            <Fragment>
                <FormBusca
                    setDividas={setDividas}
                    setVazio={setVazio}
                    fetchDividas={fetchDividas}
                />
            </Fragment>
            {vazio ? <Fragment>
                <Alert variant='danger'>Por tratar-se de um município pequeno, não há nenhuma pessoa ou empresa cadastrado na lista de dívida ativa do Portal da Transparência para evitar constrangimentos públicos.</Alert>
            </Fragment> :
                <Fragment>
                    <h5>Empresas e Pessoas com dívida ativa no município:</h5><br />
                    <Row xs={3}>
                        {dividas.map((divida, index) =>
                            <Divida
                                divida={divida}
                                key={index}
                            />
                        )}
                    </Row>
                </Fragment>}
        </Fragment>

    )
}

export default ListarDividas;